import t from "@ext/localization/locale/translate";
import { Prose } from "@ui-kit/Prose";
import { Fragment } from "react";

export const SearchContentHelp = () => {
	return (
		<Prose className="space-y-6 [&>div]:leading-7 font-normal text-muted [&_code]:font-normal">
			<div>
				{renderTemplate(t("search.help.exactDesc"), {
					exact: <code>"</code>,
					exact_word_example: <code>{t("search.help.exact_word_example")}</code>,
					exact_phrase_example: <code>{t("search.help.exact_phrase_example")}</code>,
				})}
			</div>
			<div>
				{renderTemplate(t("search.help.excludeDesc"), {
					exclude: <code>-</code>,
					exclude_word_example: <code>{t("search.help.exclude_word_example")}</code>,
					exclude_phrase_example: <code>{t("search.help.exclude_phrase_example")}</code>,
				})}
			</div>
			<div>
				{renderTemplate(t("search.help.includeDesc"), {
					include: <code>+</code>,
					include_word_example: <code>{t("search.help.include_word_example")}</code>,
					include_phrase_example: <code>{t("search.help.include_phrase_example")}</code>,
				})}
			</div>
		</Prose>
	);
};

const renderTemplate = (template: string, values: Record<string, React.ReactNode>) => {
	const parts: React.ReactNode[] = [];
	let remaining = template;

	while (remaining.length > 0) {
		const newlineIndex = remaining.indexOf("\n");

		let firstKey: string | null = null;
		let firstIndex = Infinity;

		for (const key of Object.keys(values)) {
			const token = getTemplateKey(key);
			const index = remaining.indexOf(token);

			if (index !== -1 && index < firstIndex) {
				firstIndex = index;
				firstKey = key;
			}
		}

		if (newlineIndex !== -1 && newlineIndex < firstIndex) {
			if (newlineIndex > 0) {
				parts.push(remaining.slice(0, newlineIndex));
			}

			parts.push(<br key={parts.length} />);

			remaining = remaining.slice(newlineIndex + 1);
			continue;
		}

		if (firstKey == null) {
			parts.push(remaining);
			break;
		}

		const token = getTemplateKey(firstKey);

		if (firstIndex > 0) {
			parts.push(remaining.slice(0, firstIndex));
		}

		parts.push(<Fragment key={parts.length}>{values[firstKey]}</Fragment>);

		remaining = remaining.slice(firstIndex + token.length);
	}

	return parts;
};

const getTemplateKey = (name: string) => {
	return `{{${name}}}`;
};
